var map = {
	"./ArrowDown.svg": "ea2b",
	"./ArrowUp.svg": "ea55",
	"./ShareFriends.svg": "db26",
	"./backButton.svg": "15e8",
	"./bell.svg": "2fa4",
	"./bellBan.svg": "83b1",
	"./calendar.svg": "0870",
	"./closeEyes.svg": "8d84",
	"./collection.svg": "6c06",
	"./detailArrow.svg": "ff0f",
	"./detailCollection.svg": "cfa6",
	"./detailShare.svg": "1968",
	"./frequency.svg": "72cb",
	"./hPBG.svg": "d6c8",
	"./headerBG.svg": "11a4",
	"./influence.svg": "b176",
	"./interpretation.svg": "68fd",
	"./isCollection.svg": "0530",
	"./labelAgricultural.svg": "2372",
	"./labelBond.svg": "bcb9",
	"./labelChemical.svg": "384d",
	"./labelCurrency.svg": "08da",
	"./labelDigiccy.svg": "8ed5",
	"./labelEnergy.svg": "171b",
	"./labelIndex.svg": "45a9",
	"./labelMetal.svg": "aa16",
	"./labelShares.svg": "db76",
	"./logo.svg": "bb69",
	"./logoTag.svg": "7e76",
	"./mechanism.svg": "a789",
	"./moreArrow.svg": "4b32",
	"./openApp.svg": "bc50",
	"./openAppMarket.svg": "89f9",
	"./openEyes.svg": "ebc3",
	"./qq.svg": "1430",
	"./qqShare.svg": "e9fb",
	"./search.svg": "8e8d",
	"./searchMini.svg": "c7ae",
	"./service.svg": "4e04",
	"./signInBG.svg": "dddd",
	"./sina.svg": "b3a8",
	"./stBox.svg": "938a",
	"./stDown.svg": "8ac5",
	"./stUp.svg": "b961",
	"./subscribe.svg": "8c1e",
	"./symbolInfoButton.svg": "7013",
	"./tabMarket.svg": "ddfa",
	"./tabMarketOn.svg": "a89b",
	"./tabMy.svg": "4c9d",
	"./tabMyOn.svg": "3778",
	"./tabNewsFlash.svg": "1e14",
	"./tabNewsFlashOn.svg": "4829",
	"./tabStrategy.svg": "e2fa",
	"./tabStrategyOn.svg": "b5ee",
	"./wechat.svg": "80da",
	"./wechatMoments.svg": "b1cf",
	"./wechatShare.svg": "8a6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";